import { gql } from '@grandvisionhq/graphql';

const unknownLoyaltyDetailsFailure = gql`
  fragment UnknownSetLoyaltyDetailsFailureFragment on UnknownSetLoyaltyDetailsFailure {
    message
    code
  }
`;
const invalidLoyaltyCardNumber = gql`
  fragment InvalidLoyaltyCardNumberFragment on InvalidLoyaltyCardNumber {
    message
    code
  }
`;

export { invalidLoyaltyCardNumber, unknownLoyaltyDetailsFailure };
//# sourceMappingURL=loyalty-point-failure.js.map
